/**
 * Link management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class LinkManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async uploadLink(file: File | Blob, params?: Record<string, any>): Promise<Record<string, any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.session.post('/api/cdp/cdp_link/extend/upload', { data: formData, params, headers: {} });
  }

  async downloadTemplate(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/cdp_link/extend/downloadTemplate', {
      params,
      responseType: 'blob',
    });
  }
}
